module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#pen",
      toString: function () {
        return this.url;
      }
    }